import { Box } from '@mui/material';

// Responsive KPI grid. `columns` defaults to 4 but adapts down on small screens.
const KpiGrid = ({ columns = 4, children }) => (
  <Box
    sx={{
      display: 'grid',
      gap: 1.25,
      gridTemplateColumns: {
        xs: 'repeat(2, 1fr)',
        sm: `repeat(${Math.min(columns, 4)}, 1fr)`,
        md: `repeat(${columns}, 1fr)`,
      },
    }}
  >
    {children}
  </Box>
);

export default KpiGrid;
